(() => {
  const loader =
    document.currentScript ||
    document.querySelector("script[data-search-idle-style]");
  const href = loader?.dataset.searchIdleStyle;
  let readyPromise;

  const load = () => {
    if (!href) return Promise.resolve();
    if (readyPromise) return readyPromise;

    const existing = Array.from(
      document.querySelectorAll('link[rel="stylesheet"]'),
    ).find((link) => link.href === href);
    if (existing) return Promise.resolve();

    readyPromise = new Promise((resolve, reject) => {
      const style = document.createElement("link");
      style.rel = "stylesheet";
      style.href = href;
      style.addEventListener("load", resolve, { once: true });
      style.addEventListener("error", reject, { once: true });
      document.head.appendChild(style);
    }).catch((error) => {
      readyPromise = null;
      throw error;
    });

    return readyPromise;
  };

  const isSearchControl = (target) =>
    target.closest(
      ".wt-header__search, .wt-header__search-trigger, search-drawer",
    );

  document.addEventListener(
    "pointerover",
    (event) => {
      if (isSearchControl(event.target)) load().catch(() => undefined);
    },
    { capture: true, passive: true },
  );
  document.addEventListener(
    "focusin",
    (event) => {
      if (isSearchControl(event.target)) load().catch(() => undefined);
    },
    true,
  );
  document.addEventListener(
    "pointerdown",
    (event) => {
      if (isSearchControl(event.target)) load().catch(() => undefined);
    },
    { capture: true, passive: true },
  );

  window.loadSearchIdleStyles = load;
})();
